/**
 * Whether an office can write, with the SAME rule the database enforces in
 * public.is_office_active (migration 049, used by the RLS write checks and by the
 * read-only migration 203): an office writes only if its status is not 'suspended'
 * or 'deleted' and it is not a trial whose trial_ends_at has passed.
 *
 * The screens use this instead of checking only 'suspended', so they never offer an
 * action the database will refuse (an expired trial looked writable and silently
 * lost every change).
 */
export type OfficeWriteBlock = 'suspended' | 'deleted' | 'trial_expired'

export function officeWriteBlock(
  status: string | null | undefined,
  plan: string | null | undefined,
  trialEndsAt: string | null | undefined,
  now: number = Date.now(),
): OfficeWriteBlock | null {
  if (status === 'suspended') return 'suspended'
  if (status === 'deleted') return 'deleted'
  if (plan === 'trial' && trialEndsAt && new Date(trialEndsAt).getTime() <= now) return 'trial_expired'
  return null
}

/** Why a control is disabled when the office cannot write: the tooltip every
 *  screen shows next to a locked action. */
export function writeBlockTitle(block: OfficeWriteBlock | null, t: (k: string) => string): string | undefined {
  if (!block) return undefined
  if (block === 'trial_expired') return t('billing.trialExpired')
  if (block === 'deleted') return t('cases.writeBlock.deleted')
  return t('billing.suspended')
}
